/* eslint-disable no-process-env */
import { useEffect, useState } from 'react';
import { useMeContext } from '~/modules/me/useMeContext';
import { useIsBreakpointDown } from '~/modules/common/hooks';

export const aptrinsic = 'aptrinsic';
const sourceUrl = 'https://web-sdk.aptrinsic.com/api/aptrinsic.js';
const MOBILE_CHANNEL = '3';

export const updateTagKeyChannel = (tagKey, channel) => {
  if (!tagKey) return tagKey;
  const parts = tagKey.split('-');

  if (parts.length > 2) {
    parts[2] = channel + parts[2].substring(1);

    return parts.join('-');
  }

  return tagKey;
};

export const getProductCode = gainsightTagKey => {
  if (!gainsightTagKey || !gainsightTagKey.includes('-')) return '';

  return gainsightTagKey.split('-')[1];
};

const initGainsight = (tagKey, setScriptLoaded) => {
  window[aptrinsic] =
    window[aptrinsic] ||
    ((...args) => {
      (window[aptrinsic].q = window[aptrinsic].q || []).push(args);
    });
  window[aptrinsic].p = tagKey;
  const script = document.createElement('script');

  script.async = true;
  script.src = `${sourceUrl}?a=${tagKey}`;
  script.onload = () => {
    setScriptLoaded && setScriptLoaded(true);
  };
  script.onerror = () => {
    setScriptLoaded && setScriptLoaded(false);
  };
  const c = document.getElementsByTagName('script')[0];

  c?.parentNode?.insertBefore(script, c);
};

export const useInitGainsightPX = () => {
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const isMobile = useIsBreakpointDown('sm');
  const {
    id,
    firstName,
    lastName,
    emailAddress,
    companyKey,
    tenantSlug,
    gainsightTagKey,
    isGainsightDisabled
  } = useMeContext();

  useEffect(() => {
    if (!id || !scriptLoaded || !window[aptrinsic]) return;
    const productCode = getProductCode(gainsightTagKey);

    window[aptrinsic](
      'identify',
      {
        id: `rpcn_${id}`,
        email: emailAddress,
        firstName,
        lastName
      },
      {
        id: `rpcn_${tenantSlug}`,
        name: companyKey,
        productVersion: 'Polaris',
        productCode
      }
    );
  }, [
    id,
    tenantSlug,
    scriptLoaded,
    gainsightTagKey,
    emailAddress,
    firstName,
    lastName,
    companyKey
  ]);

  useEffect(() => {
    if (!gainsightTagKey || scriptLoaded || isGainsightDisabled) return;

    const tagKey = isMobile
      ? updateTagKeyChannel(gainsightTagKey, MOBILE_CHANNEL)
      : gainsightTagKey;

    initGainsight(tagKey, setScriptLoaded);
  }, [isMobile, gainsightTagKey, scriptLoaded, isGainsightDisabled]);
};
